import { Dimension } from "dimtext";

function createBoxRefPlanes() {
  return {
    type: "box",
    left: { name: "Left", value: Dimension.from(0, "inches") },
    right: { name: "Right", value: Dimension.from(50, "inches") },
    bottom: { name: "Bottom", value: Dimension.from(0, "inches") },
    top: { name: "Top", value: Dimension.from(50, "inches") },
  };
}

function createCrossRefPlanes() {
  return {
    type: "cross",
    horizontal: { name: "Horizontal", value: Dimension.from(50, "inches") },
    vertical: { name: "Vertical", value: Dimension.from(50, "inches") },
  };
}

function roundTo64th(inches: number) {
  return Math.round(inches * 64) / 64;
}

function createGridLines(width: number, height: number, xSubdivs: number, ySubdivs: number) {
  const hSpacing = roundTo64th(height / ySubdivs);
  const vSpacing = roundTo64th(width / xSubdivs);
  const hLast = height - hSpacing * (ySubdivs - 1);
  const vLast = width - vSpacing * (xSubdivs - 1);

  return {
    type: "grid",
    y_offset: { name: "Y-Offset", value: Dimension.from(0, "inches") },
    horizontal: Array.from({ length: ySubdivs }, (_, i) => ({
      name: `Horizontal ${i + 1}`,
      value: i === ySubdivs - 1
        ? Dimension.from(hLast, "inches")
        : Dimension.from(hSpacing, "inches"),
      keyed: false,
    })),
    x_offset: { name: "X-Offset", value: Dimension.from(0, "inches") },
    vertical: Array.from({ length: xSubdivs }, (_, i) => ({
      name: `Vertical ${i + 1}`,
      value: i === xSubdivs - 1
        ? Dimension.from(vLast, "inches")
        : Dimension.from(vSpacing, "inches"),
      keyed: false,
    })),
  }
}

function gridlinePositions(
  planes: ReturnType<typeof createGridLines>,
  direction: "horizontal" | "vertical",
  min: number = 0
) {
  const p0 = direction === "horizontal" ? planes.y_offset : planes.x_offset;
  const lines = planes[direction];

  const p0Val = p0?.value.toNumber("inches") ?? 0;
  const v = [min + p0Val];
  lines.forEach((line, i) => {
    v.push(line.value.toNumber("inches") + v[i]);
  });

  return v;
}

function positionsToLines(
  positions: number[],
  direction: "horizontal" | "vertical",
  min: number = 0
) {
  const offsets = positions.map((p, i) => {
    if (i === 0) return p;
    return p - positions[i - 1];
  });
  const first = offsets.shift();
  return {
    [direction === "horizontal" ? "y_offset" : "x_offset"]: {
      name: `${direction === "horizontal" ? "Y" : "X"}-Offset`,
      value: Dimension.from((first ?? 0) - min, "inches"),
    },
    [direction]: offsets.map((o, i) => ({
      name: `${direction === "horizontal" ? "Horizontal" : "Vertical"} ${i + 1}`,
      value: Dimension.from(o, "inches"),
      keyed: false,
    }))
  };
}

export { createBoxRefPlanes, createCrossRefPlanes, createGridLines, gridlinePositions, positionsToLines };
